module.exports = __webpack_public_path__ + "img/icon_fp_link6.b73e6e58.svg";